// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q_pC","list":"styles_list__W0wfy","disableSelection":"styles_disableSelection__2_YTY"};